{
  "RESET_PASSWORD": {
    "TITLE": "تغییر رمز عبور",
    "DESCRIPTION": "آدرس ایمیلی را که برای ورود به Chatwoot استفاده می‌کنید وارد کنید تا دستورالعمل‌های بازیابی رمز عبور را دریافت کنید.",
    "GO_BACK_TO_LOGIN": "اگر می خواهید به صفحه ورود به سیستم بازگردید،",
    "EMAIL": {
      "LABEL": "ایمیل",
      "PLACEHOLDER": "لطفا ایمیل خود را وارد کنید.",
      "ERROR": "ظاهرا این ایمیل صحیح نیست، لطفا اصلاح کنید."
    },
    "API": {
      "SUCCESS_MESSAGE": "لینک ریست کردن رمز عبور به ایمیلتان ارسال شد.",
      "ERROR_MESSAGE": "متأسفانه ارتباط با سرور برقرار نشد، مجددا امتحان کنید."
    },
    "SUBMIT": "ثبت"
  }
}
